export default __webpack_public_path__ + "static/offerPreviewImg-2724bbdc83bdd43a11b192b667806417.png";